import React from 'react'
import { FormattedMessage } from 'react-intl'
import EmployeeCard, { IEmployee } from 'components/EmployeeCard'
import CheckboxGroup from 'components/CheckboxGroup'

import messages from './messages'
import styles from './EmployeesSection.scss'

const employee_stub: IEmployee = {
  name: 'Silvia Rodriguez Mera',
  title: 'Publicidad y Relaciones Públicas',
  location: 'Bilbao Area, Spain',
  profileUrl: ['https://es.linkedin.com/in/silvia-rodriguez-mera-867655175'],
  photoUrl:
    'https://media-exp1.licdn.com/dms/image/C4E03AQGdXxIjzCZ9JQ/profile-displayphoto-shrink_200_200/0/1542469561484?e=1617840000&v=beta&t=LWHrUZafrFm-ALw_MDQ0FbtXqiC-rWn7oK3EHlXwKmQ',
}

type EnrichedEmployeesLocationType = {
  originalLocation: string
  count: number
  coordinates?: string
}

export type IEmployeesSection = {
  employees: Array<IEmployee>
  enrichedEmployeeLocations: Array<EnrichedEmployeesLocationType>
}

// eslint-disable-next-line no-unused-vars
const employeesStub: Array<IEmployee> = [
  employee_stub,
  employee_stub,
  employee_stub,
  employee_stub,
  employee_stub,
  employee_stub,
  employee_stub,
  employee_stub,
  employee_stub,
  employee_stub,
  employee_stub,
  employee_stub,
  employee_stub,
]

// eslint-disable-next-line no-unused-vars
const enrichedEmployeesLocationsStub: Array<EnrichedEmployeesLocationType> = [
  { originalLocation: 'Denmark', count: 3, coordinates: '55.6760968, 12.5683372' },
  { originalLocation: 'Canada', count: 2, coordinates: '43.653226, -79.3831843' },
  { originalLocation: 'US/Chicago Metropolitan Area, USA', count: 2, coordinates: '41.7435073, -88.0118473' },
  { originalLocation: 'US/United States', count: 1, coordinates: '37.09024, -95.712891' },
  { originalLocation: 'ES/Barcelona', count: 1, coordinates: '41.3850639, 2.1734035' },
  { originalLocation: 'Taiwan', count: 1, coordinates: '23.69781, 120.960515' },
  { originalLocation: 'US/California', count: 14, coordinates: '33.8726016, -118.2848067' },
  { originalLocation: 'Sweden', count: 17, coordinates: '59.32932349999999, 18.0685808' },
  { originalLocation: 'South Africa', count: 12, coordinates: '-33.9248685, 18.4240553' },
  { originalLocation: 'US/Washington', count: 1, coordinates: '47.6061031, -122.3320534' },
  { originalLocation: 'Portugal', count: 5, coordinates: '39.39987199999999, -8.224454' },
  { originalLocation: 'Brazil', count: 9, coordinates: '-23.5431786, -46.6291845' },
  { originalLocation: 'US/Florida', count: 7, coordinates: '28.5828156, -81.3399414' },
  { originalLocation: 'France', count: 14, coordinates: '48.856614, 2.3522219' },
  { originalLocation: 'Puerto Rico', count: 1, coordinates: '18.220833, -66.590149' },
  { originalLocation: 'Germany', count: 18, coordinates: '51.4516041, 6.640814799999999' },
  { originalLocation: 'ES/Madrid', count: 60, coordinates: '40.4167754, -3.7037902' },
  { originalLocation: 'Argentina', count: 10, coordinates: '-38.416097, -63.61667199999999' },
  { originalLocation: 'Norway', count: 4, coordinates: '61.3967311, 11.5627369' },
  { originalLocation: 'Mexico', count: 10, coordinates: '19.4314047, -98.95820479999999' },
  { originalLocation: 'ES/Biscay', count: 122, coordinates: '43.2630126, -2.9349852' },
  { originalLocation: 'Pakistan', count: 11, coordinates: '31.5203696, 74.35874729999999' },
  { originalLocation: 'Russia', count: 1, coordinates: '61.52401, 105.318756' },
  { originalLocation: 'China', count: 3, coordinates: '32.060255, 118.796877' },
  { originalLocation: 'US/Boston Metropolitan Area, USA', count: 6, coordinates: '42.3600709, -71.0588305' },
  { originalLocation: 'United Kingdom', count: 18, coordinates: '52.6368778, -1.1397592' },
  { originalLocation: 'Peru', count: 7, coordinates: '-9.189967, -75.015152' },
  { originalLocation: 'US/Georgia', count: 2, coordinates: '33.8498184, -84.4382721' },
  { originalLocation: 'ES/Spain', count: 10, coordinates: '40.46366700000001, -3.74922' },
  { originalLocation: 'Greece', count: 6, coordinates: '39.074208, 21.824312' },
  { originalLocation: 'Belgium', count: 5, coordinates: '51.2194475, 4.4024643' },
  { originalLocation: 'ES/Cantabria', count: 4, coordinates: '43.46230569999999, -3.8099803' },
  { originalLocation: 'Israel', count: 1, coordinates: '31.046051, 34.851612' },
  { originalLocation: 'ES/Cáceres', count: 1, coordinates: '39.4752765, -6.3724247' },
  { originalLocation: 'Malaysia', count: 5, coordinates: '3.0738379, 101.5183469' },
  { originalLocation: 'ES/Valencia', count: 16, coordinates: '39.4699075, -0.3762881' },
  { originalLocation: 'Uruguay', count: 8, coordinates: '-32.522779, -55.765835' },
  { originalLocation: 'US/Massachusetts', count: 1, coordinates: '42.4184296, -71.1061639' },
  { originalLocation: 'India', count: 2, coordinates: '11.0168445, 76.9558321' },
  { originalLocation: 'Italy', count: 16, coordinates: '45.4642035, 9.189982' },
  { originalLocation: 'Bolivia', count: 5, coordinates: '-16.290154, -63.58865299999999' },
  { originalLocation: 'Venezuela', count: 5, coordinates: '10.4805937, -66.90360629999999' },
  { originalLocation: 'Romania', count: 1, coordinates: '44.4267674, 26.1025384' },
  { originalLocation: 'Cyprus', count: 7, coordinates: '35.126413, 33.429859' },
  { originalLocation: 'Finland', count: 1, coordinates: '61.92410999999999, 25.7481511' },
  { originalLocation: 'Netherlands', count: 4, coordinates: '52.3675734, 4.9041389' },
  { originalLocation: 'Turkey', count: 1, coordinates: '41.03332899999999, 29.10136' },
  { originalLocation: 'Chile', count: 8, coordinates: '-35.675147, -71.542969' },
  { originalLocation: 'US/Texas', count: 2, coordinates: '29.7318873, -95.4135535' },
  { originalLocation: 'ES/Álava', count: 1, coordinates: '42.850237, -2.6728711' },
  { originalLocation: 'Serbia', count: 1, coordinates: '44.016521, 21.005859' },
  { originalLocation: 'Vietnam', count: 1, coordinates: '14.058324, 108.277199' },
  { originalLocation: 'North Macedonia', count: 1, coordinates: '41.608635, 21.745275' },
  { originalLocation: 'Saudi Arabia', count: 5, coordinates: '23.885942, 45.079162' },
  { originalLocation: 'Indonesia', count: 4, coordinates: '-6.2174945, 106.8178377' },
  { originalLocation: 'Paraguay', count: 1, coordinates: '-23.442503, -58.443832' },
  { originalLocation: 'El Salvador', count: 2, coordinates: '13.794185, -88.89653' },
  { originalLocation: 'US/Washington Metropolitan Area, USA', count: 1, coordinates: '39.1289725, -77.3783789' },
  { originalLocation: 'Iran', count: 4, coordinates: '32.427908, 53.688046' },
  { originalLocation: 'Colombia', count: 1, coordinates: '4.570868, -74.297333' },
  { originalLocation: 'Honduras', count: 2, coordinates: '15.199999, -86.241905' },
  { originalLocation: 'Hungary', count: 1, coordinates: '47.162494, 19.5033041' },
  { originalLocation: 'Bulgaria', count: 1, coordinates: '42.733883, 25.48583' },
  { originalLocation: 'ES/Murcia', count: 2, coordinates: '38.1398141, -1.366216' },
  { originalLocation: 'ES/Las Palmas', count: 1, coordinates: '28.1008837, -15.4653897' },
  { originalLocation: 'Panama', count: 1, coordinates: '8.537981, -80.782127' },
  { originalLocation: 'The Gambia', count: 1, coordinates: '13.443182, -15.310139' },
  { originalLocation: 'Kenya', count: 1, coordinates: '-0.023559, 37.906193' },
  { originalLocation: 'Guatemala', count: 1, coordinates: '14.6114708, -90.563609' },
]

export default function EmployeesSection({ employees, enrichedEmployeeLocations }: IEmployeesSection) {
  // const FilterButton = () => (
  //   <Button color="primary" outline={!enrichedEmployeeLocations.length} className={styles.filterButton}>
  //     <Icon name="filters" size="regular" />
  //   </Button>
  // );
  //
  // const filterOptions = enrichedEmployeesLocationsStub.map(({ originalLocation, count }) => ({
  //   value: originalLocation,
  //   label: (
  //     <FormattedMessage
  //       {...messages.option}
  //       values={{
  //         label: originalLocation,
  //         count
  //       }}
  //     />
  //   )
  // }));

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h3 className={styles.summary}>
          <div className={styles.title}>
            <FormattedMessage {...messages.employees} />
          </div>
        </h3>
      </header>
      <div className={styles.content}>
        <div className={styles.filters}>
          <CheckboxGroup
            type='regular'
            name='employeeFilters'
            options={enrichedEmployeeLocations.map(({ originalLocation, count }) => `${originalLocation} (${count})`)}
            selections={[]}
            onChange={() => {}}
          />
        </div>
        <div>
          <div className={styles.title}>
            <FormattedMessage
              {...messages.identified}
              values={{ count: employees ? employees.length : 0 }}
              tagName='span'
            />
          </div>
          <div className={styles.employees}>
            {!!employees &&
              employees.map(employee => (
                <div className={styles.employee} key={employee.name}>
                  <EmployeeCard
                    name={employee.name}
                    title={employee.title}
                    location={employee.location}
                    photoUrl={employee.photoUrl}
                    profileUrl={employee.profileUrl}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}
